module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/winpementees.json
// module id = 692
// module chunks = 263909125441205